import { useStore } from '../store/useStore';
import { useT } from '../i18n/useT';
import { Modal } from './Modal';

const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);
const mod = isMac ? '⌘' : 'Ctrl';

const GROUPS: { titleKey: string; items: [string, string][] }[] = [
  {
    titleKey: 'shortcuts.general',
    items: [
      [`${mod} K`, 'sc.palette'],
      [`${mod} O`, 'sc.quickOpen'],
      [`${mod} ⇧ D`, 'sc.today'],
      ['?', 'sc.sheet'],
      [`${mod} N`, 'sc.new'],
      [`${mod} F`, 'sc.find'],
      [`${mod} \\`, 'sc.sidebar'],
    ],
  },
  {
    titleKey: 'shortcuts.view',
    items: [
      [`${mod} ⇧ V`, 'sc.viewmode'],
      [`${mod} ⇧ P`, 'sc.pane'],
      ['Esc', 'sc.focus'],
      // Tab indents inside the editor, so it does not move focus on its own;
      // without this line a keyboard user has no way to learn how to get out.
      ['Esc, Tab', 'sc.leaveEditor'],
    ],
  },
  {
    titleKey: 'shortcuts.formatting',
    items: [
      [`${mod} B`, 'sc.bold'],
      [`${mod} I`, 'sc.italic'],
      [`${mod} E`, 'sc.code'],
      ['/', 'sc.slash'],
      ['Tab, ⇧ Tab', 'sc.tableCells'],
    ],
  },
];

/** Keyboard-shortcuts cheat sheet (opened via the palette or `?`). */
export function ShortcutsDialog() {
  const t = useT();
  const open = useStore((s) => s.shortcutsOpen);
  const setOpen = useStore((s) => s.setShortcutsOpen);
  if (!open) return null;

  return (
    <Modal onClose={() => setOpen(false)} title={t('shortcuts.title')} className="mb-modal-wide">
      <div className="mb-shortcuts-grid">
        {GROUPS.map((g) => (
          <div key={g.titleKey} className="mb-shortcuts-col">
            <h3>{t(g.titleKey)}</h3>
            {g.items.map(([keys, labelKey]) => (
              <div key={labelKey} className="mb-shortcut-row">
                <span>{t(labelKey)}</span>
                <kbd>{keys}</kbd>
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className="mb-modal-actions">
        <button className="mb-btn mb-btn-primary" onClick={() => setOpen(false)}>
          {t('common.done')}
        </button>
      </div>
    </Modal>
  );
}
